module.exports = __webpack_public_path__ + "static/media/Vijay Naidoo Pic.4c36a541.jpg";